import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import stepperSlice from "../StepperSlice/stepperSlice";
import sessionStorage from "redux-persist/es/storage/session";
import ServiceTypeSlice from "../ServiceTypeSlice/ServiceTypeSlice";
import patientSlice from "../PatientSlice/PatientSlice";
import adminSlice from "../AdminSlice/AdminSlice";
import localStorage from "redux-persist/lib/storage";
import loginSlice from "../AdminSlice/LoginSlice";
import framesSlice from "../FramesSlice";
import {
  secureSessionStorage,
  secureLocalStorage,
} from "../../utils/storageCrypto";
import reportsSlice from "../ReportSlice/ReportSlice";

const stepperConfig = {
  key: "stepper",
  storage: secureSessionStorage,
  whitelist: ["stepper"],
};
const servicetypeConfig = {
  key: "servicetype",
  storage: secureSessionStorage,
  whitelist: [
    "servicetype",
    "location",
    "gender",
    "locationId",
    "postalCode",
    "insurance",
    "distance",
    "currentLocation",
  ],
};
const PatienDetailconfig = {
  key: "patientdetails",
  storage: secureSessionStorage,
  whitelist: [
    "patients",
    "selectedProvider",
    "isExistingPatient",
    "insurancePolicy",
    "selectedTime",
    "patientdetail",
    "rulesConfig",
    "utm",
    "sessionId",
    "isPassedPayLoad",
    "patientFromShortUrlData",
    // 'showWarningStatus',

    "selectedSubService",
    "widgetStorage",
    "IntakeReferrer",
    "IntakeCondition",
    "IntakeSymptoms",
    "Intakedisruptive",
    "showWarningStatus",
    "IntakeQuestion",
    "IntakeDynamicQuestions",
    "leadFormData",
    "newPatientInsuranceDraft",
    "newPatientPersonalData",
  ],
};
const PatientFilterConfig = {
  key: "patientdetails",
  storage: secureLocalStorage,
  whitelist: ["patientFilters", "patientSearchQuery", "patientTabValue","ownSession"],
};
// NEW: Reports filter config
const ReportsFilterConfig = {
  key: "reportsfilters",
  storage: secureLocalStorage,
  whitelist: ["reportsFilters", "reportsTabValue", "reportsToggleValue"],
};
const adminDetailconfig = {
  key: "admin",
  storage: secureSessionStorage,
  whitelist: ["adminDetails", "clientBrands"],
};
const adminLoginDetail = {
  key: "adminLogin",
  storage: secureLocalStorage,
  whitelist: ["remindEmail"],
};
const framesConfig = {
  key: "frames",
  storage: secureSessionStorage,
  whitelist: ["framesId", "widgetId", "clientPath", "widgetUrl"],
};

const persistReducerStepper = persistReducer(stepperConfig, stepperSlice);
const persistServiceType = persistReducer(servicetypeConfig, ServiceTypeSlice);
const persistReducerPatient = persistReducer(PatienDetailconfig, patientSlice);
const persistReducerPatientFilter = persistReducer(
  PatientFilterConfig,
  patientSlice,
);
const persistReducerReportsFilter = persistReducer(
  ReportsFilterConfig,
  reportsSlice,
);
const persistReducerAdmin = persistReducer(adminDetailconfig, adminSlice);
const persistReducerAdminLogin = persistReducer(adminLoginDetail, loginSlice);
const persistReducerFrames = persistReducer(framesConfig, framesSlice);

export const store = configureStore({
  reducer: {
    step: persistReducerStepper,
    servicetype: persistServiceType,
    Patientdetails: persistReducerPatient,
    PtientFilter: persistReducerPatientFilter,
    Reports: persistReducerReportsFilter,
    admin: persistReducerAdmin,
    login: persistReducerAdminLogin,
    frames: persistReducerFrames,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});

export const persistor = persistStore(store);
